import { useRef } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import {
  CarouselWrapper,
  ScrollArea,
  ArrowButton,
  DateCard,
} from "./DateCarousel.styles";

const LeftArrowIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
  </svg>
);

const RightArrowIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M8.59 16.58L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.42z"/>
  </svg>
);

const DateCarousel = ({ activeDate, onDateSelect }) => {
  const { webSettingData } = useSelector((state) => state.busLists);
  const scrollRef = useRef(null);

  // Generate 15 dates starting from today or centered around active date (no past dates)
  const today = moment().startOf("day");
  const activeMoment = activeDate ? moment(activeDate) : moment();

  let startMoment = moment(activeMoment).subtract(5, "days");
  if (startMoment.isBefore(today)) {
    startMoment = moment(today);
  }

  const dates = [];
  for (let i = 0; i < 14; i++) {
    dates.push(moment(startMoment).add(i, "days"));
  }

  const handleScroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 200;
      scrollRef.current.scrollLeft += direction === "left" ? -scrollAmount : scrollAmount;
    }
  };

  const primaryColor = webSettingData?.buttoncolor || "#1FBA30";

  return (
    <CarouselWrapper>
      <ArrowButton color={primaryColor} onClick={() => handleScroll("left")} title="Scroll Left">
        <LeftArrowIcon />
      </ArrowButton>

      <ScrollArea ref={scrollRef}>
        {dates.map((date, idx) => {
          const isActive = date.isSame(activeMoment, "day");
          return (
            <DateCard
              key={idx}
              active={isActive}
              activeColor={primaryColor}
              onClick={() => onDateSelect(date.toDate())}
            >
              <span className="day-name">{date.format("ddd")}</span>
              <span className="day-number">{date.format("DD")}</span>
            </DateCard>
          );
        })}
      </ScrollArea>

      <ArrowButton color={primaryColor} onClick={() => handleScroll("right")} title="Scroll Right">
        <RightArrowIcon />
      </ArrowButton>
    </CarouselWrapper>
  );
};

export default DateCarousel;
